import React, { useRef } from "react";
import PosterCard from "@/components/film/PosterCard";
import { Navigation, Thumbs, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import breakpoints from "@/constants/breakpoinst";
import * as Text from "@/components/text";
import useWindowSize from "@/hooks/useWindowSize";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";

// import "swiper/css";
// import "swiper/css/free-mode";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/thumbs";
import { useEffect } from "react";
import useSwiperRef from "@/hooks/useSwiperRef";
import { getStrapiImage } from "@/utils/strapiFunctions";

export default function MoviesSlider({ movies = [], simple }) {
  const paginationRef = useRef(null);
  // const nextRef = useRef(null);
  // const prevRef = useRef(null);
  const windowSize = useWindowSize();
  const [prevEl, prevRef] = useSwiperRef();
  const [nextEl, nextRef] = useSwiperRef();

  return (
    <div className="space-y-10" style={{ marginTop: "2rem" }}>
      <Swiper
        // onInit={(swiper) => {
        //   swiper.params.navigation.prevEl = prevRef.current;
        //   swiper.params.navigation.nextEl = nextRef.current;
        //   swiper.navigation.init();
        //   swiper.navigation.update();
        // }}
        slidesPerView={1}
        breakpoints={{
          [breakpoints.xl]: {
            slidesPerView: 4.2,
            slidesPerGroup: 4,
            spaceBetween: 24,
          },
          [breakpoints.lg]: {
            slidesPerView: 4.2,
            slidesPerGroup: 4,
            spaceBetween: 24,
          },
          [breakpoints.md]: {
            slidesPerView: 3.2,
            slidesPerGroup: 3,
            spaceBetween: 24,
          },
          [breakpoints.sm]: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
        }}
        modules={[Thumbs, Navigation, Pagination]}
        pagination={{
          clickable: true,
          type: "bullets",
          el: paginationRef.current,
          currentClass: "bg-neutral-900",

          bulletClass: "block w-6 h-1 bg-neutral-50 ",
          bulletActiveClass: "bg-neutral-900",
        }}
        // navigation={{
        //   enabled: true,
        //   nextEl: nextRef.current && nextRef.current,
        //   prevEl: prevRef.current,

        // }}
        navigation={{
          prevEl,
          nextEl,
          hiddenClass: "hidden",
          disabledClass: "text-neutral-50 border-neutral-50",
        }}
      // onInit={(swiper) => {
      //   swiper.params.navigation.prevEl = prevRef.current;
      //   swiper.params.navigation.nextEl = nextRef.current;
      //   swiper.navigation.init();
      //   swiper.navigation.update();
      // }}
      >
        {movies.map(({ id, attributes: movie }) => (
          <SwiperSlide key={id}>
            <PosterCard
              size={
                windowSize.width > breakpoints.xl
                  ? "xl"
                  : windowSize.width > breakpoints.lg
                    ? "lg"
                    : windowSize.width > breakpoints.md
                      ? "md"
                      : windowSize.width > breakpoints.sm
                        ? "sm"
                        : "sm"
              }
              grid_details={true}
              theme="light"
              slug={`/catalogo/${movie.filmSlug}`}
              film_name={movie.film_name}
              film_ama={movie.film_ama}
              film_image={getStrapiImage(movie?.film_cover_image, "small")}
              film_link={`/catalogo/${movie.filmSlug}`}
              film_original_title={movie.film_original_title}
              film_directors={movie.Directores.map(({ Director }) => Director)}
              film_synopsis={movie.film_excerpt}
              film_streaming_link={movie.film_stream_link || ""}
            // film_metadata={{
            //   year: movie.film_year,
            //   duration: movie.film_length || "",
            //   countries: [
            //     movie.countries.map((c) => c.countries).join(", "),
            //   ],
            //   // languages: movie.idiomas.data.map(({attributes:{name}}) => name).join(", "),
            // }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      {
        simple ? (
          <div className="relative">
            <div className="flex items-center justify-center gap-5 align-middle">
              <button
                ref={prevRef}
                className={
                  windowSize.width > breakpoints.lg
                    ? "btn-b border-neutral-900/36 absolute -left-20 bottom-[11rem] border p-2 min-[1024px]:hidden"
                    : "hidden"
                }
              >
                <ArrowLeftIcon className="h-5 w-5" />
              </button>
              {/* <div className="flex gap-5" ref={paginationRef}></div> */}
              <button
                ref={nextRef}
                className={
                  windowSize.width > breakpoints.lg
                    ? "btn-a border-neutral-900/36 absolute -right-20 bottom-[11rem] border p-2 min-[1024px]:hidden"
                    : "hidden"
                }
              >
                <ArrowRightIcon className="h-5 w-5" />
              </button>
            </div>
          </div>
        ) : null
        // <div className="hidden md:flex lg:my-0 justify-center ">
        //   <div className="flex gap-5 align-middle justify-center items-center">
        //     <button ref={beforeRef} className="border-neutral-900/36 p-2 border">
        //       <ArrowLeftIcon className="h-5 w-5" />
        //     </button>
        //     <div className="flex gap-5" ref={paginationRef}></div>
        //     <button ref={afterRef} className="p-2 border border-neutral-900/36">
        //       <ArrowRightIcon className="h-5 w-5" />
        //     </button>
        //   </div>
        // </div>
      }
    </div>
  );
}
